// Characters chosen to be unambiguous when read aloud or typed — no O/0, I/1, L, S/5.
const CODE_ALPHABET = 'ABCDEFGHJKMNPQRTUVWXYZ23456789'

export const PAIRING_CODE_LENGTH = 6
export const PAIRING_CODE_PATTERN = new RegExp(`^[${CODE_ALPHABET}]{${PAIRING_CODE_LENGTH}}$`)

export function generatePairingCode(length = PAIRING_CODE_LENGTH): string {
  if (typeof crypto === 'undefined' || typeof crypto.getRandomValues !== 'function') {
    // Server-side fallback — never actually pairs, just satisfies types during SSR
    return ''.padEnd(length, 'A')
  }
  const bytes = new Uint32Array(length)
  crypto.getRandomValues(bytes)
  let out = ''
  for (let i = 0; i < length; i++) {
    out += CODE_ALPHABET[bytes[i]! % CODE_ALPHABET.length]
  }
  return out
}

export function isValidPairingCode(code: string): boolean {
  return PAIRING_CODE_PATTERN.test(code)
}

export function normalizePairingCode(raw: string): string {
  return raw.toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, PAIRING_CODE_LENGTH)
}

// Each game registers under its own peer-id namespace so pairing codes from
// different games can't collide on the shared signaling server.
export function peerIdForGameCode(peerNamespace: string, code: string): string {
  return `sfg-${peerNamespace}-${code.toUpperCase()}`
}
